import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export default class DateAdapter extends AdapterDateFns {
  getWeekdays = (): string[] => weekDays;
}
